export const NEW_PET_ID = -1;
export const defaultTab = 'notes';

export const endpoints = {
	get: 'getPet',
	list: 'petList',
	create: 'createPet',
	update: 'updatePet',
	delete: 'deletePet',
};
